export class EndCustomersData{
    endCustomerId:number;
    endCustomerName:string;
    constructor(endCustomerId:number, endCustomerName:string){
        this.endCustomerId = endCustomerId;
        this.endCustomerName = endCustomerName;
    }
}